export enum SearchObjectType {
  Creative = 'Creative',
  ContentFeed = 'ContentFeed',
  ContentSet = 'ContentSet',
  ProductFeed = 'ProductFeed',
  LocationFeed = 'LocationFeed',
  LocationSet = 'LocationSet',
}

